import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccessTextTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${60 * Screen.widthRatio}px;
  padding-bottom: ${30 * Screen.widthRatio}px;
`;

export default AccessTextTitle;
